import { useMutation, useQueryClient } from '@tanstack/react-query';

import { exercisesService } from '../services';
import type { AssignExerciseInput } from '../types';

import { clientExercisesKeys } from './useExercises';

export type AssignExerciseToClientInput = AssignExerciseInput & { clientId: string };

/**
 * Mutation hook that assigns an exercise to a single client. Unlike
 * `useAssignExercise(clientId)` — which fixes the client at hook-construction
 * time and is correct for the from-client dialog flow — this variant accepts
 * the clientId per-call, which is what the catalog/detail-driven assign
 * dialog needs (one exercise, picker yields the client).
 */
export function useAssignExerciseToClient() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ clientId, ...input }: AssignExerciseToClientInput) =>
      exercisesService.assignToClient(clientId, input),
    onSuccess: (_data, vars) => {
      void qc.invalidateQueries({
        queryKey: clientExercisesKeys.operation('by-client', { clientId: vars.clientId }),
      });
    },
  });
}
